import * as actions from "../actions/tables";
import { pushSafe, removeValue, setSafe } from "../util/storeHelper";
/**
 * reducer for changes to the window state
 */
export const tableReducer = {
    reducers: {
        [actions.setAttributeVisible]: (state, payload) => {
            const { tableId, attributeId, visible } = payload;
            return setSafe(state, [tableId, "attributes", attributeId, "enabled"], visible);
        },
        [actions.setAttributeSort]: (state, payload) => {
            const { tableId, attributeId, direction } = payload;
            // ensure sorting for other columns is reset because we don't support sorting by multiple
            // attributes atm
            Object.keys(state[tableId]?.attributes ?? {}).forEach((iter) => {
                state = setSafe(state, [tableId, "attributes", iter, "sortDirection"], "none");
            });
            return setSafe(state, [tableId, "attributes", attributeId, "sortDirection"], direction);
        },
        [actions.setAttributeFilter]: (state, payload) => {
            const { tableId, attributeId, filter } = payload;
            return attributeId === undefined
                ? setSafe(state, [tableId, "filter"], undefined)
                : filter === null
                    ? setSafe(state, [tableId, "filter", attributeId], undefined)
                    : setSafe(state, [tableId, "filter", attributeId], filter);
        },
        [actions.setGroupingAttribute]: (state, payload) => setSafe(state, [payload.tableId, "groupBy"], payload.attributeId),
        [actions.collapseGroup]: (state, payload) => {
            const { tableId, groupId, collapse } = payload;
            return collapse
                ? pushSafe(state, [tableId, "collapsedGroups"], groupId)
                : removeValue(state, [tableId, "collapsedGroups"], groupId);
        },
        [actions.setCollapsedGroups]: (state, payload) => setSafe(state, [payload.tableId, "collapsedGroups"], payload.groups),
    },
    defaults: {},
};
